module.exports = __webpack_public_path__ + "img/Identity-Pattern3.651598a8.svg";